import { Asset, AssetCategory, AssetStatus } from '@/types/resources/asset';
import dayjs from 'dayjs';
import { faker } from '@faker-js/faker';

const assetCategories: { category: AssetCategory; subCategories: string[] }[] = [
  {
    category: 'maintenance',
    subCategories: ['Preventiva', 'Corretiva', 'Preditiva']
  },
  {
    category: 'it',
    subCategories: ['Computadores', 'Servidores', 'Redes']
  },
  {
    category: 'furniture',
    subCategories: ['Móveis', 'Decoração', 'Acessórios']
  },
  {
    category: 'amenities',
    subCategories: ['Academia', 'Piscina', 'Equipamentos Esportivos']
  },
  {
    category: 'security',
    subCategories: ['Câmeras', 'Alarmes', 'Sistemas de Acesso']
  }
];

const generateAsset = (id: number): Asset => {
  const categoryData = faker.helpers.arrayElement(assetCategories);
  const category = categoryData.category;
  const subCategory = faker.helpers.arrayElement(categoryData.subCategories);
  const purchaseDate = faker.date.past({ years: 5 });
  const warrantyEndDate = dayjs(purchaseDate).add(faker.number.int({ min: 1, max: 5 }), 'year').toDate();
  const status = faker.helpers.arrayElement(Object.values(AssetStatus));


  return {
    id: `AST${String(id).padStart(3, '0')}`,
    name: `${faker.commerce.productName()} ${faker.commerce.productAdjective()}`,
    category,
    subCategory,
    status,
    location: `Edifício ${faker.helpers.arrayElement(['A', 'B', 'C'])}, Sala ${faker.number.int({ min: 101, max: 599 })}`,
    purchaseDate,
    purchasePrice: {
      amount: parseFloat(faker.commerce.price({ min: 100, max: 50000 })),
      currency: 'USD',
    },
    warranty: {
      startDate: purchaseDate,
      endDate: warrantyEndDate,
      details: 'Garantia padrão do fabricante',
      provider: faker.company.name(),
    },
    specifications: {
      brand: faker.company.name(),
      model: faker.commerce.product(),
      serialNumber: faker.string.alphanumeric(15).toUpperCase(),
      dimensions: `${faker.number.int({ min: 1, max: 10 })}m x ${faker.number.int({ min: 1, max: 10 })}m x ${faker.number.int({ min: 1, max: 10 })}m`,
      weight: faker.number.int({ min: 1, max: 2000 }),
      color: faker.color.human(),
    },
    documents: [],
    activityRecords: [
      {
        timestamp: faker.date.recent(),
        type: 'created',
        performedBy: {
          id: `USR${faker.number.int({ min: 1, max: 50 })}`,
          displayName: faker.person.fullName(),
        },
      },
    ],
  };
};

export const assets: Asset[] = Array.from({ length: 235 }, (_, i) => generateAsset(i + 1));

 